export default __webpack_public_path__ + "static/media/table.81e39ab6.png";